import { render } from "./DrugLibrary.vue?vue&type=template&id=515b7404&scoped=true"
import script from "./DrugLibrary.vue?vue&type=script&lang=js"
export * from "./DrugLibrary.vue?vue&type=script&lang=js"

import "./DrugLibrary.vue?vue&type=style&index=0&id=515b7404&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-515b7404"]])

export default __exports__